import React from 'react';
import '../styles/Navbar.css';

function Navbar({ isScrolled }) {
  const smoothScroll = (e, targetId) => {
    e.preventDefault();
    const target = document.querySelector(targetId);
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  
  return (
    <nav className={`nav ${isScrolled ? 'scrolled' : ''}`} id="navbar">
      <div className="nav-container">
        <a href="#home" className="nav-logo" onClick={(e) => smoothScroll(e, '#home')}>
          TRÔ YOGA
        </a>
        <ul className="nav-links">
          <li><a href="#home" onClick={(e) => smoothScroll(e, '#home')}>Home</a></li>
          <li><a href="#principles" onClick={(e) => smoothScroll(e, '#principles')}>Principles</a></li>
          <li><a href="#power-yoga" onClick={(e) => smoothScroll(e, '#power-yoga')}>Power Yoga</a></li>
          <li><a href="#ai-chat" onClick={(e) => smoothScroll(e, '#ai-chat')}>TRO AI</a></li>
          <li><a href="#contact" onClick={(e) => smoothScroll(e, '#contact')}>Contact</a></li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
